export default "__VITE_ASSET__DlGOutEq__"